module.exports = __webpack_public_path__ + "7052bc555aa96d109cc5e08c783c8a3d.MP3";